import Axios from 'axios';
import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import getMetaTagData from '../../../../src/common/services/getMetaTagData';
import ServiceNotice from '../../../../src/component/m/pass/ServiceNotice';

import cookieCutter from 'cookie-cutter';
import { toStringByDateFormat } from "../../../../src/common/utils/dateUtil";
import { getBillingUrl, getLnbList, goLogin, isAndroid, isIOS } from "../../../../src/common/utils/passUtil";
import FoldBanner from "../../../../src/component/m/pass/FoldBanner";
import InappRestore from "../../../../src/component/m/pass/pass/InappRestore";
import PassGroup from "../../../../src/component/m/pass/pass/PassGroup";
import PassSlider from '../../../../src/component/m/pass/pass/PassSlider';
import PassVisualBox from '../../../../src/component/m/pass/pass/PassVisualBox';
import SlideBanner from "../../../../src/component/m/pass/SlideBanner";

function Pass({ metaTagData, passData, topEventBannerData, isSbsApp, loginJwt, lang, platform }) {

  //jwt 토큰 관리
  const [login_jwt, setLogin_jwt] = useState();
  const [isFoldBannerOpen, setIsFoldBannerOpen] = useState(false);
  const [displayLang, setDisplayLang] = useState('ko');
  const [isSbsAppState, setIsSbsAppState] = useState(isSbsApp);
  const [isAndroidState, setIsAndroidState] = useState(isAndroid());

  const [paddingTop, setPaddingTop] = useState('0px');

  useEffect(() => {
    if (isSbsAppState && isAndroidState) {
      setPaddingTop('50px');
    } else {
      setPaddingTop('0px');
    }
  }, [isSbsAppState, isAndroidState]);

  //화면시작시 최초 한번 시작...
  useEffect(async () => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const displayLang = cookieCutter.get('SBS_DL');
    setDisplayLang(displayLang)

    if (isSbsApp) {
      const wrap = document.querySelector('.android_wrap');
      lang === 'en' ? wrap.classList.add('eng_wrap') : wrap.classList.remove('eng_wrap');
    }

  }, [displayLang]);

  useEffect(() => {
    if (isIOS()) {
      const menu2depthListWrap = document.querySelector('.menu2depthListWrap');
      if (menu2depthListWrap) {
        menu2depthListWrap.style.display = 'none';
      }
    }
  }, [isIOS]);

  const foldBannerOpenToggleHandler = () => {
    if (isFoldBannerOpen) {
      setIsFoldBannerOpen(false);
    } else {
      setIsFoldBannerOpen(true);
    }
  };

  const subsRestore = () => {
    if (typeof window !== 'undefined') {
      try {
        window.inapp.restoreVoucher("subs");
      } catch (e) {
      }
    }
  }

  const inappRestore = () => {
    if (typeof window !== 'undefined') {
      try {
        window.inapp.restoreVoucher("inapp");
      } catch (e) {
      }
    }
  }

  const inappbillingHandler = (group, inapp_product_id, inapp_event_product_id, inapp_product_name, inapp_app_price, billingUrl) => {
    /*
      * group
      * 1. SBS play 이용권 - 자동결제 : subs
      * 2. SBS play 이용권 - 기간제 : inapp
      * 3. 포인트 : point
      * 4. SBS머니 : money
      */
    /*
      * billType
      * 결제방식
      * all - SBS & GOOGLE 결제 지원
      * sbs - SBS 결제만 지원
      * google - 구글 결제만 지원
      */
    let billType = 'all';
    let appProductId = ''; //구글 상품 ID
    let appCombiId = ''; //구글 상품 ID
    let eventCheck = false;

    if (group == 'subs') { // 자동 결제
      // if (eventCheck) {
      if (isAndroid()) {
        appProductId = 'sub_' + inapp_product_id.toLowerCase();
      } else { // IOS 
        appProductId = 'kr.co.sbs.sbsplayer.' + inapp_product_id;
      }
      appCombiId = inapp_product_id;
    } else { // 기간제 결제

      if (isAndroid()) {
        appProductId = 'term_' + inapp_product_id.toLowerCase();
      } else { // IOS 
        appProductId = 'kr.co.sbs.sbsplayer.' + inapp_product_id;
      }
      appCombiId = inapp_product_id;
    }

    const encodingProductName = encodeURIComponent(inapp_product_name);

    if (loginJwt) {
      if (isSbsApp) {

        const convertPrice = (priceStr) => {
          return parseInt(priceStr.replace(/[^0-9]/g, ''), 10);
        };


        if (typeof window !== 'undefined') {
          try {
            console.log(billType, group, appProductId, appCombiId, inapp_product_name, convertPrice(inapp_app_price), billingUrl)
            /* Android (- method : 결제방식 ( “all” - SBS & GOOGLE 결제 지원 "sbs” - SBS 결제만 지원 “google” - 구글 결제만 지원)
            - skuType : 결제 타입 sub(구독), inap(기간제)
            - productId: 상품번호 (ex: sub_cb...term_cb...)
            - combiId : 상품 코드 (ex: CB..)
            - billingUrl : 결제 URL (사용자가 개발자 결제 선택 시 이동할 URL, url encoding 처리))
            */
            if (isAndroid()) {
              window.inapp.purchaseVoucherWithPrice(billType, group, appProductId, appCombiId, inapp_product_name, convertPrice(inapp_app_price), billingUrl);
            } else {
              // IOS skuType : 결제 타입  sub(구독), inap(기간제),  productId : 상품 id (ex: kr.co...CB..), inapp_product_name 보내기로 협의함 
              try {
                window.inapp.purchaseVoucher_v2(group, appProductId, encodingProductName, convertPrice(inapp_app_price));
              } catch (e) {
                window.inapp.purchaseVoucherWithPrice(group, appProductId, encodingProductName);
              }
            }
          } catch (e) {
            try {
              if (isAndroid()) {
                window.inapp.purchaseVoucher(billType, group, appProductId, appCombiId, billingUrl);
              } else { // ios 
                window.inapp.purchaseVoucher(group, appProductId, encodingProductName);
              }
            } catch (e) {
            }
          }
        }
      } else {
        if (typeof window !== 'undefined') {
          window.location.href = billingUrl;
        }
      }
    } else {
      if (typeof window !== 'undefined') {

        if (isIOS()) {// IOS 비로그인시 앱 스킴 처리 
          /* IOS
          - skuType : 결제 타입  sub(구독), inap(기간제)
          - productId : 상품 id
          */
          window.location.href = `siapp://login?type=purchasevoucher&skuType=${group}&productId=${appProductId}&productname=${encodingProductName}`;

        } else { // (안드로이드, 웹은 로그인 페이지로)

          window.location.href = goLogin();

        }
      }
    }
  }

  return (
    <>
      <Head>
        <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_2023_M_PASSMONEY_URL} />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <script key='gnb_js_url' type='text/javascript' src={process.env.NEXT_PUBLIC_GNB_JS_URL} />
        <script src='//developers.kakao.com/sdk/js/kakao.min.js' />
        <meta name='description' content={metaTagData.shareDescription} />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={metaTagData.shareTitle || ''} />
        <meta property='og:description' content={metaTagData.shareDescription || ''} />
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={metaTagData.shareTitle || ''} />
        <meta name='nate:description' content={metaTagData.shareDescription || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>
      <div id="container" className="contents">
        <div className="passmoneyContents" style={{ paddingTop }}>{/* 페이지 명 클래스 (style은 퍼블과 협의됨 ios 여백 이슈) */}
          {/* lnb list */}
          {isSbsApp && getLnbList('app')}
          <div className="passmoneyCont_pass area01">
            {/* 스와이퍼 배너영역 */}
            {/* {(lang == 'ko' || lang == '') && topEventBannerData && (<SlideBanner data={topEventBannerData} />)} */}
            {/* 배너 : 확장성 배너 */}
            {/* open-banner 추가시 하단 내용 보임. */}
            {/* {passData.pass_event_banner && (<div className={`foldBannerWrap ${isFoldBannerOpen ? 'open-banner' : ''}`}><FoldBanner data={passData.pass_event_banner} onClick={foldBannerOpenToggleHandler} isFoldBannerOpen={isFoldBannerOpen} /></div>)} */}
            <PassSlider lang={lang} isAndroid={isAndroid()} isIOS={isIOS()} isSbsApp={isSbsApp} />
          </div>
          <div class="passmoneyCont_pass area02">
            <div class="passVisualText_w">
              <PassVisualBox lang={lang} />
            </div>
          </div>
          {/* 이용권 리스트 */}
          <div class="passmoneyCont_pass area03">
            {passData.pass_group && (
              <div className="passContents">
                <PassGroup data={passData.pass_group} loginJwt={loginJwt} isAndroid={isAndroid()} isIOS={isIOS()} isSbsApp={isSbsApp} inappbillingHandler={inappbillingHandler} platform={platform} displayLang={displayLang} lang={lang} />
                {isSbsApp && (<InappRestore data={passData.google_inapp_restore} subsRestore={subsRestore} inappRestore={inappRestore} lang={lang} />)}
              </div>
            )}
          </div>
          {/* 서비스 이용 유의사항 */}
          <div className="passmoneyCont_pass area04">
            {passData.service_notice && (<div className="noticeList_wrap"><ServiceNotice data={passData.service_notice}></ServiceNotice></div>)}
            {isSbsApp && (<div className="noticeList_wrap"><ServiceNotice data={isAndroid() ? passData.google_service_notice : passData.itunes_service_notice}></ServiceNotice></div>)}
          </div>
          {/*<!-- 광고 : 날개배너 -->*/}
          <div className="contents_bottom_ad">
            <div className="bottom_ad_inner">
              <iframe title='배너광고' display='block' src='/html/m/pass.htm' width='300px' height='250px' scrolling='no' frameBorder='0' align='middle' marginWidth='0' marginHeight='0' />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const getPassData = async (lang) => {
  let result = null;

  try {
    const apiUrl = lang == 'ko' ? process.env.NEXT_PUBLIC_API_PASS_KO : process.env.NEXT_PUBLIC_API_PASS_EN;
    const passData = await Axios.get(apiUrl, { timeout: 3000 });
    result = passData.data ? { ...passData.data } : null;

    //console.log(result);

  } catch (error) {
    console.error(error);
    result = null;
  }

  return result;
};

const getTopEventBanner = async () => {
  let result = null;

  //console.log('NEXT_PUBLIC_API_TOP_EVENT_BANNER :>> ', process.env.NEXT_PUBLIC_API_TOP_EVENT_BANNER);

  try {
    const today = toStringByDateFormat(new Date);

    const topEventBannerData = await Axios.get(process.env.NEXT_PUBLIC_API_TOP_EVENT_BANNER, { timeout: 3000 });

    result = topEventBannerData.data ? { ...topEventBannerData.data } : null;
    result = result.top_event_banner.filter(topEventBanner => topEventBanner.start_date <= today && topEventBanner.end_date >= today)


  } catch (error) {
    console.error(error);
    result = null;
  }

  return result;
};

export async function getServerSideProps(ctx) {

  //console.log('getServerSideProps');
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { cookies } = ctx.req;
  const { LOGIN_JWT = null } = cookies;
  const { JOIN_PLATFORM = null } = cookies;
  const { pageSection, pageCategory, lang = 'ko' } = ctx.query;

  let metaTagData;
  let passData;
  let topEventBannerData;

  try {
    metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory); // 메타 데이터 불러오는 부분(각페이지마다 있어야함)
    passData = await getPassData(lang);
    topEventBannerData = await getTopEventBanner();
  } catch (error) {
    console.error(error);
  }

  return {
    props: {
      loginJwt: LOGIN_JWT,
      platform: JOIN_PLATFORM,
      passData: passData,
      topEventBannerData: topEventBannerData,
      metaTagData,
      lang
    }
  };
}

export default Pass;